import React, { Component } from 'react';
import PropTypes from 'prop-types';
import json0 from '@minervaproject/ot-json0';
import richText from '@minervaproject/rich-text';
import ShareDB from '@teamwork/sharedb/lib/client';

import { withSocket } from './SocketProvider';

json0.type.registerSubtype(richText.type);
ShareDB.types.register(json0.type);
ShareDB.types.defaultType = json0.type;

export const sharedb = ShareDB;
export const json = json0;

const ShareDBContext = React.createContext();

class _ShareDBProvider extends Component {
  constructor(props) {
    super(props);
    const {
      sockets: { sharedb },
    } = this.props;
    this.sharedb = new ShareDB.Connection(sharedb);
    this.state = {
      status: '',
    };
  }

  componentDidMount() {
    this.sharedb.on('state', (state) => {
      this.setState({
        status: state.toString(),
      });
    });
  }

  getContext = () => ({
    sharedb: this.sharedb,
    ...this.state,
  });

  render() {
    return (
      <ShareDBContext.Provider value={this.getContext()} {...this.props} />
    );
  }
}

_ShareDBProvider.propTypes = {
  sockets: PropTypes.object.isRequired,
};

export const withShareDB = () => (WrappedComponent) =>
  function (props) {
    return (
      <ShareDBContext.Consumer>
        {(context) => <WrappedComponent {...context} {...props} />}
      </ShareDBContext.Consumer>
    );
  };

export const ShareDBProvider = withSocket()(_ShareDBProvider);
